import { Link } from "react-router-dom";
import { mangaCategories } from "@/mocks/categories";

const CATEGORY_ICONS: Record<string, string> = {
  love: "ri-heart-3-fill",
  campus: "ri-graduation-cap-fill",
  city: "ri-building-2-fill",
  comedy: "ri-emotion-laugh-fill",
  sweet: "ri-heart-2-fill",
  complete: "ri-flag-2-fill",
};

export default function CategoryNav() {
  return (
    <section className="container-site py-12 md:py-16" aria-labelledby="category-title">
      <div className="flex flex-col items-center text-center">
        <span className="chip-tag">分类导航</span>
        <h2 id="category-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          想看的漫画都在这里
        </h2>
        <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
          六大分类精选，从校园甜宠到都市恋曲，总有一部作品让你心动。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
        {mangaCategories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center rounded-lg border border-background-200/70 bg-background-50 p-5 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-xl text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={CATEGORY_ICONS[cat.slug] || "ri-book-2-fill"} aria-hidden="true" />
            </span>
            <span className="mt-3 font-heading text-base font-bold text-foreground-950">{cat.name}漫画</span>
            <span className="mt-1 text-xs leading-relaxed text-foreground-600">{cat.description}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}